import bgimage from "../../assets/images/whatismtbg.png";

const WhatIsMtProgram = () => {
  return (
    <section
      id="mt-staj-programlari-zirvesi-nedir"
      className="w-full flex justify-center items-center relative bg-[url('../../assets/images/whatismtbg.png')] bg-cover bg-center bg-no-repeat"
    >
      {/* <img src={bgimage} alt="Mt&Staj Programı Nedir?"></img> */}
      <div className="w-full md:w-4/5 lg:w-4/5 xl:w-4/5 px-5 py-10 sm:py-32 lg:py-56 lg:px-0 max-w-screen-xl flex justify-end">
        <div
          data-aos="fade-left"
          className="w-1/2 flex flex-col items-end space-y-2 lg:space-y-5"
        >
          <div
            style={{ fontFamily: "Gotham" }}
            className="flex flex-col items-end space-y-0 lg:space-y-2"
          >
            <h4 className="text-base sm:text-2xl md:text-4xl lg:text-7xl font-bold text-white">
              MT&STAJ
            </h4>
            <div className="bg-[url('../../assets/images/bg-yellow.png')] bg-contain bg-center bg-no-repeat w-min">
              <h4 className="text-base sm:text-2xl md:text-4xl lg:text-7xl text-[#28495B] font-bold p-[3px]  md:p-4">
                PROGRAMLARI
              </h4>
            </div>
            <h4 className="text-base sm:text-2xl md:text-4xl lg:text-7xl font-bold text-white">
              ZİRVESİ NEDİR?
            </h4>
          </div>

          <p
            style={{ fontFamily: "Poppins" }}
            className="text-xs md:text-base lg:text-xl font-normal text-white text-right lg:pl-[130px]"
          >
            MT&Staj Programları Zirvesi, şirketlerin düzenlediği genç yetenek
            programlarının süreçlerini ve detaylarını potansiyel adaylarına
            aktardığı bir kariyer etkinliğidir.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatIsMtProgram;
